import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(
  ({ theme }) => ({
    padding: '1rem',
    marginBottom: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      padding: '2.5rem 7.5rem 0',
      marginBottom: '5.5rem'
    },
    [theme.breakpoints.up('md')]: {
      padding: '4rem 7.5rem 0',
      marginBottom: '6rem'
    },
    [theme.breakpoints.up('xl')]: {
      padding: '4rem 15rem 0'
    }
  })
);

export const GridContainer = styled(Box)(
  ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    rowGap: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr'
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '2fr 3fr'
    }
  })
);

export const SubGridContainer = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr',
  rowGap: '1.5rem'
});

export const ImageContainer = styled(Box)(
  ({ theme }) => ({
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '80%'
    }
  })
);
